import React from 'react';
import { FormInput, FormSelect } from '@/components/UI';
import type { ScorecardFeatureRow } from './types';

interface AddRuleSelectorFieldsProps {
    feature: ScorecardFeatureRow;
    selectorValues: Record<string, string>;
    setSelectorValues: React.Dispatch<React.SetStateAction<Record<string, string>>>;
}

const AddRuleSelectorFields = ({ feature, selectorValues, setSelectorValues }: AddRuleSelectorFieldsProps) => {
    if (Object.keys(feature.selectors).length === 0) return null;

    return (
        <div>
            <div className="text-sm font-medium text-zinc-200 mb-2">Selectors</div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {Object.entries(feature.selectors).map(([selectorKey, selectorSchema]) => {
                    const selectorValue = selectorValues[selectorKey] ?? '';

                    if (selectorSchema.allowedValues?.length) {
                        return (
                            <FormSelect
                                helpText={selectorSchema.description ?? undefined}
                                key={selectorKey}
                                label={selectorSchema.label ?? selectorKey}
                                options={selectorSchema.allowedValues.map((allowedValue) => ({
                                    value: String(allowedValue),
                                    label: String(allowedValue)
                                }))}
                                value={selectorValue}
                                onChange={(event) =>
                                    setSelectorValues((previous) => ({
                                        ...previous,
                                        [selectorKey]: event.target.value
                                    }))
                                }
                            />
                        );
                    }

                    if (selectorSchema.type === 'boolean') {
                        return (
                            <FormSelect
                                helpText={selectorSchema.description ?? undefined}
                                key={selectorKey}
                                label={selectorSchema.label ?? selectorKey}
                                options={[
                                    { value: 'true', label: 'true' },
                                    { value: 'false', label: 'false' }
                                ]}
                                value={selectorValue || 'false'}
                                onChange={(event) =>
                                    setSelectorValues((previous) => ({
                                        ...previous,
                                        [selectorKey]: event.target.value
                                    }))
                                }
                            />
                        );
                    }

                    return (
                        <FormInput
                            helpText={selectorSchema.description ?? undefined}
                            key={selectorKey}
                            label={selectorSchema.label ?? selectorKey}
                            type={
                                selectorSchema.type === 'integer' || selectorSchema.type === 'number' || selectorSchema.type === 'timestamp'
                                    ? 'number'
                                    : 'text'
                            }
                            value={selectorValue}
                            onChange={(event) =>
                                setSelectorValues((previous) => ({
                                    ...previous,
                                    [selectorKey]: event.target.value
                                }))
                            }
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default AddRuleSelectorFields;
